<template>
    <div>
        <div :id="id"></div>
    </div>
</template>
<script>
    import { Chart } from '@antv/g2'
    /**
     * 图表绘制逻辑
     */
    export default {
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            }, // 组件的配置,
            chartData: {
                type: Array,
                default: () => new Array()
            }
        },
        data () {
            return {
                id: 'chartContainer',
                chart: null
            }
        },
        watch: {  
            chartData (data) {
                if (this.chart) {
                    this.chart.clear()
                    this.chart.data(this.chartData)
                    this.renderChart()
                } else {
                    this.initRenderChart()
                }
            }
        },
        created () {
            this.id += parseInt(Math.random() * 1000)
        }, 
        methods: {
            initRenderChart () {
                this.chart = new Chart({
                    container: this.id,
                    autoFit: true,
                    height: 320,
                    theme: 'cheery'
                })
                this.chart.data(this.chartData)
                this.renderChart()
            },
            renderChart () {
                this.chart.tooltip({
                    showCrosshairs: true,
                    shared: true,
                })
                this.attrs.chart.forEach(el => {
                    if (this.attrs.type == 'line') { // 绘制折线图
                        this.lineReander(el)
                    } else if (this.attrs.type == 'interval') { // 绘制柱状图
                        this.lineRender(el)
                    }
                })
                // 提示文字的处理
                this.attrs.tooltip.forEach(el => {
                    let scale = {}
                    scale[el.field] = {
                        formatter: (val) => {
                            return val + el.word
                        }
                    }
                    this.chart.scale(scale)
                })
                
                this.chart.render()
            },
            lineReander (obj) {
                this.chart
                    .line()
                    .position(obj.x + '*' + obj.y)
                    .color(obj.color, ['#CC3300', '#0033FF', '#FF9900', '#66CC00', '#6633CC'])
                    .shape(obj.shape||'solid')
            },
            lineRender (obj) {
                this.chart.interaction('active-region');
                this.chart
                    .interval()
                    .position(obj.x + '*' + obj.y)
                    .color(obj.color)
                    .adjust([
                        {
                            type: 'dodge',
                            marginRatio: 0,
                        },
                    ])
            } 
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/g2-chart/src/chartRender.vue